export default __webpack_public_path__ + "static/media/minivan.58399209.svg";